import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
	fetchMedicalInformation, updateMedicalInformation,
	MEDICAL_INFORMATION_FETCH_REQUEST, MEDICAL_INFORMATION_FETCH_SUCCESS, MEDICAL_INFORMATION_FETCH_FAILURE,
	MEDICAL_INFORMATION_UPDATE_REQUEST, MEDICAL_INFORMATION_UPDATE_SUCCESS, MEDICAL_INFORMATION_UPDATE_FAILURE
} from './actions';
import { getChild } from '../reducer';
import { withNamespaces } from 'react-i18next';
import FormComponents from '../assessmentForms/Components';
import AssessmentForm from '../assessmentForms/Form';
import ReduxBlockUi from 'react-block-ui/redux';
import 'react-block-ui/style.css';
import { SubmissionError } from 'redux-form';
import { getFormValues, change, clearSubmitErrors } from 'redux-form';
import { toast, ToastContainer } from 'react-toastify';

class MedicalInformation extends Component {

	componentDidMount() {
		this.props.fetchMedicalInformation(Number(this.props.match.params.id));
	}

	handleFormSubmit(values, requiredFields, validationFunc) {
		const { t, child, medicalInformation, updateMedicalInformation, clearFormErrors, history } = this.props;

		clearFormErrors();

		let errors = {};
		if (requiredFields) {
			requiredFields.forEach(field => {
				if (values[field] == null || values[field] === '') {	// null, undefined or empty are invalid, 0 is a valid value
					errors[field] = t('Validator_Required');
				}
			});
		}

		if (validationFunc) {
			errors = Object.assign(errors, validationFunc(values, t));
		}

		// throw redux-form error if fields are missing when submiting form
		if (Object.keys(errors).length > 0) {
			//toast.error(t('FO_IndividualConsultationForm_ValidationErrors'));
			throw new SubmissionError(errors);
		}

		updateMedicalInformation(child.id, { ...medicalInformation, content: values }, history);
	}

	render() {
		const { child, medicalInformation, currentFormValues, changeFormValue, t } = this.props;
		const { component, requiredFields, validationFunc } = medicalInformation ?
			FormComponents(medicalInformation, { showResults: false }, currentFormValues, changeFormValue) :
			{ component: null, requiredFields: [], validationFunc: null };

		return (
			<div className='medical-information'>
				<h3>{t('FO_Child_MedicalInformation')}</h3>
				<ReduxBlockUi block={[MEDICAL_INFORMATION_FETCH_REQUEST, MEDICAL_INFORMATION_UPDATE_REQUEST]}
					unblock={[MEDICAL_INFORMATION_FETCH_SUCCESS, MEDICAL_INFORMATION_FETCH_FAILURE, MEDICAL_INFORMATION_UPDATE_SUCCESS, MEDICAL_INFORMATION_UPDATE_FAILURE]}>
					{medicalInformation && <AssessmentForm
						//title={child && child.fullName}
						description=''
						formComponent={component}
						backPath={`/children/${child ? child.id : ''}`}
						enableFinal={false} showFormActionsOnTop={false}
						saveDraftButtonText={t('Common_Save')} saveDraftButtonIcon={<React.Fragment />}
						onSubmit={(values, isFinal) => this.handleFormSubmit(values, requiredFields, validationFunc)}
						initialValues={medicalInformation.content}
						isReadonly={false}
					/>}
				</ReduxBlockUi>
				<ToastContainer />
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const childId = Number(ownProps.match.params.id);
	const child = getChild(state.parent, childId);

	const { entities: { medicalInformations }, lookups: { medicalInformationForm } } = state;

	const medicalInformation = medicalInformations[childId] || (medicalInformationForm && {
		id: 0,
		formId: medicalInformationForm.id,
		childId,
		name: medicalInformationForm.name,
		content: {}
	});

	return {
		medicalInformation,
		child,
		currentFormValues: getFormValues('customForm')(state)
	};
};

export default connect(mapStateToProps, {
	fetchMedicalInformation,
	updateMedicalInformation,
	changeFormValue: (field, value) => change('customForm', field, value),
	clearFormErrors: () => clearSubmitErrors('customForm')
})(withNamespaces()(MedicalInformation));
